import React from 'react';
import { useSelector } from 'react-redux';
import { Query } from 'react-apollo';
import Box from '@material-ui/core/Box';
import Sessions from './Sessions';
import Stats from './Stats';
import AdmissionStatus from './AdmissionStatus';
import AdmissionType from './AdmissionType';
import Helmet from 'react-helmet';
import { GET_STATUSES } from 'graphql/student/stats';
import Spin from 'components/common/Spin';
import Alert from '@material-ui/lab/Alert';
import { toUserTimezone } from 'utils';
import moment from 'moment';

const MyStats = ({}) => {
  const user = useSelector((s) => s.user.user);
  const profile = useSelector((s) => s.student.profile);

  return (
    <>
      <Helmet title="My Stats" />
      <Query
        query={GET_STATUSES}
        variables={{ userId: user.id, sub: user.sub }}
        fetchPolicy={'cache-and-network'}
      >
        {({ data, loading }) => {
          if (!data) return <Spin spinning />;
          const currentDate = moment().format('YYYY-MM-DD');
          const expirationDate = moment(
            toUserTimezone(data.subscriptions[0].end_date),
          ).format('YYYY-MM-DD');
          const programEndDate = moment(expirationDate).diff(
            currentDate,
            'days',
          );
          return (
            <div>
              { programEndDate <= 0 ? (
                <Alert severity="info" style={{ marginBottom: 20 }}>
                  
                    Program support ended on{' '}
                    {toUserTimezone(data.subscriptions[0].end_date).format(
                      'MMMM D, YYYY',
                  )}
                </Alert>
              ) : ( 
              <Alert severity="info" style={{ marginBottom: 20 }}>
             Program support ends on{' '}
                  {toUserTimezone(data.subscriptions[0].end_date).format(
                    'MMMM D, YYYY',
              )}
            </Alert> )}
              <Box marginBottom={3}>
                <Stats data={data} />
              </Box>
              <Box marginBottom={3}>
                <Sessions data={data.credits} student={profile} />
              </Box>
              <Box marginBottom={3}>
                <AdmissionStatus data={data} />
              </Box>
              <Box marginBottom={3}>
                <AdmissionType data={data} />
              </Box>
            </div>
          );
        }}
      </Query>
    </>
  );
};

export default MyStats;
